import {MoodBad} from '@material-ui/icons';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';

import Screen from './screen';
import {getElection} from './store/selectors';

const Unavailable: React.FC = () => {
  const {t} = useTranslation();
  const election = useSelector(getElection);

  const getMessage = () => {
    if (election && election.configs.message_early_access) {
      return election.configs.message_early_access;
    }
    return t('unavailaible.default-message');
  };

  return (
    <Screen isPageAuth={true} hideToolbar={true}>
      <div className="borded-icon-large external-circle ">
        <div className="borded-icon-large">
          <div className="borded-icon-large intern-circle">
            <MoodBad width="50" height="50" fontSize="large" />
          </div>
        </div>
      </div>

      <h2 className="primary-title text-center">{t('unavailaible.title')}</h2>
      <p className="default-subtitle mt-0  text-center">{getMessage()}</p>
    </Screen>
  );
};

export default Unavailable;



// WEBPACK FOOTER //
// ./src/features/election/Unavailable.tsx